export default __webpack_public_path__ + "static/LUTEIN-EYE-ANATOMY-2e55d1dd98fedd98672bb2a413368c93.jpg";